export default __webpack_public_path__ + "static/media/web.fcea3549.png";